<template>
  <a-modal 
    :title="title" 
    :visible="hidden"
    @ok="ok" 
    @cancel="cancel"
    :forceRender="true"
    :destroyOnClose="true"
    :maskClosable="false"
    width="800px"
    okText="确定"
    cancelText="取消">
    <template slot="footer">
      <a-button @click="cancel">取消</a-button>
      <a-button :loading="saveLoading" type="primary" @click="ok">确定</a-button>
    </template>
    <a-form-model
      ref="ruleForm"
      class="create-form"
      :model="form"
      :rules="rules"
      :validateOnRuleChange="true"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="配方名称" prop="formulaName">
        <a-input size="small" placeholder="输入配方名称" v-model.trim="form.formulaName" />
      </a-form-model-item>
      <a-form-model-item label="动物类型" prop="animal">
        <a-input
          v-if="form.id && isChange"
          :style="inputStyle"
          v-model="animalName"
          placeholder="请选择动物类型"
        >
          <a-icon slot="suffix" type="down" style="font-size: 12px;color: #ccc;" />
        </a-input>
        <a-cascader 
          ref="cascader"
          :options="animal"
          :load-data="loadAnimalData"
          :style="form.id ? cascaderStyle : ''"
          @change="onChange"
          size="small"
          :placeholder="formValue.animal"
          v-model="form.animal"
        />
      </a-form-model-item>
      <a-form-model-item label="养分选择表"  prop="linkId">
        <a-select
          @change="nutritionChange"
          placeholder="选择养分表"
          :defaultValue="defaultNutrition"
          :allowClear="true"
          v-model="form.linkId"
        >
          <a-select-option v-for="(item,index) in nutrition.records" :title="item.name" :key="index" :value="item.id">
            {{item.name}}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="价格来源" prop="priceSource">
        <a-select placeholder="选择价格来源" v-model="form.priceSource" :options="priceOption" />
      </a-form-model-item>
      <a-form-model-item label="客户来源"  prop="customId">
        <a-select
          placeholder="选择客户"
          :allowClear="true"
          v-model="form.customId"
        >
          <a-select-option v-for="(item,index) in customer.records" :title="item.customerName" :key="index" :value="item.id">
            {{item.customerName}}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="设定盘重" prop="totalWeight">
        <a-space type="flex">
        <a-input-number style="flex:1;" step="1" size="small" type="number" v-model="form.totalWeight">
        </a-input-number><span>KG</span></a-space>
      </a-form-model-item>
      <!-- "moistureVolatilizeStart": 0,
      "moistureVolatilizeUtil": 0, -->
      <a-form-model-item label="水分挥发" prop="moistureVolatilizeStart">
        <a-space type="flex">
        <a-input-number step="0.01" size="small" type="number" :min="0" :max="100"  @change="startChange" v-model="moistureVolatilizeStart" :precision="2">
        </a-input-number><span>%</span></a-space>
      </a-form-model-item>
      <!-- <a-form-model-item label="水分挥发直到" prop="moistureVolatilizeUtil">
        <a-space type="flex">
        <a-input-number step="0.01" size="small" :min="0" :max="100" @change="utilChange"  type="number" v-model="moistureVolatilizeUtil">
        </a-input-number><span>%干物质</span></a-space>
      </a-form-model-item> -->
      <a-form-model-item label="分析基础" prop="analysisBase">
        <a-space>
        <a-input-number size="small" v-model="form.analysisBase" :disabled="true">
        </a-input-number>
        <span>KG</span>
        </a-space>
      </a-form-model-item>
      <a-form-model-item ref="remark" label="备注" prop="remark">
        <a-textarea size="small" :maxLength="150" v-model="form.remark" placeholder="输入备注" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import {nhfMixins} from '../../untils'

export default {
  props:['hidden'],
  mixins:[nhfMixins],
  data(){
    return {
      saveLoading: false,
      isChange: true,
      animalName: '',
      inputStyle: 'position: absolute;width: 100%;top:-7px;opacity: 1;background: #fff;top:-1px;color:rgba(0, 0, 0, 0.65);',
      cascaderStyle: 'opacity: 0',
      modelCache:[],
      formValue:{
        model:'选择配方模型',
        animal:'选择动物类型',
        price:'选择价格来源'
      },
      nutrition:{
        records:[],
      },
      customer: {
        records:[]
      },
      animal:[],
      title:'新增',
      form:{
        totalWeight:1000,
        analysisBase:1,
        analysisBaseUnit:'Kg',
        priceSource:'4',
        // customId: '1'
      },
      moistureVolatilizeStart:null,
      moistureVolatilizeUtil:null,
      rules: {
        formulaName: [
          {required: true, message: '请输入配方名称', trigger: 'change'},
          {validator: this.validatorName, trigger: 'change'}
        ],
        animal: [
          { required: true, message: '请选择动物类型', trigger: 'blur'},
          {validator: this.validatorAnimal, trigger: 'blur'}
        ],
        priceSource: [{ required: true, message: '选择价格来源', trigger: 'change' }],
        linkId: [{ required: true, message: '选择养分', trigger: 'change' }],
        customId: [{ required: true, message: '选择客户', trigger: 'change' }],
        totalWeight: [{ required: true, message: '请输入盘重设定', trigger: 'change' }]
      },
      checkTitle: '',
      maxLen2: 31
    }
  },
  computed:{
    defaultNutrition(){
      return this.form && this.form.linkId  && this.form.linkId ? this.nutrition.records.map(i=>i.id === this.form.linkId)[0].name : null
    },
    animalDefault(){
      return [this.form ? this.form.animalTypeCode : null]
    }
  },
  mounted(){
    this.factoryId = window.localStorage.getItem('factoryId')
    const {id} = this.$route.query
    this.formulaId = id
    // this.getModelList()
    this.getNutrition()
    this.getCustomerList()
    this.initAnimal()
  },

  watch:{
    hidden(val){
      if(val && this.formulaId){
        this.title="编辑"
        this.formValue.price = '市场价格'
        this.detailInit()
        this.isChange = true
        // this.initAnimal()
      }
    },
  },
  
  methods:{
    getCharLen(str=''){
      let len = 0
      let strArr = str.split('')
      strArr && strArr.forEach(el => {
        if(el.charCodeAt() > 255){
          len += 3
        }else{
          len++
        }
        if(len <= this.maxLen2){
          this.checkTitle += el
        }
      })
      return len
    },
    checkNameLen(e){
      let val = e.target.value
      this.checkTitle = ''
      let len = this.getCharLen(val)
      if(len > this.maxLen2){
        this.form.formulaName = this.checkTitle
        this.$message.warning(`配方名称长度不能超过${this.maxLen2}个字节`)
      }
    },
    startChange(val){
      if(val>0){
        this.moistureVolatilizeUtil = null
      }
    },
    utilChange(val){
      if(val>0){
        this.moistureVolatilizeStart = null
      }
    },
    validatorName(rule, value, callback) {
      let msg = ''
      // let flag = false
      // let reg2 = /[`/\\~!@$^&_+=<>?:"{}|^%,;'[\]·~！@￥……&——+={}|《》？：“”【】、；‘’，。、]/im;
      let reg2 = /[*[\]：？<>/、\\.]/im;
      if(reg2.test(value)){
        // msg = `配方名称不能包含\`/\\~!@$^&_+=<>?:"{}|^%,;'[]·~！@￥……&——+={}|《》？：“”【】、；‘’，。、等特殊字符`
        msg = '配方名称不能包含*[]：？<>/、\\.等特殊字符'
        // flag = true
      }
      // 长度
      // let len = this.getCharLen(value)
      let len = value.length
      if(len > this.maxLen2){
        msg = `配方名称长度不能超过${this.maxLen2}个字符`
      }
      if(msg) callback(new Error(msg))
      callback()
    },
    validatorAnimal(rule,value,callback){
     const { animalRootId, animalTypeCode, animalTypeName} = this.form
      if( !animalRootId && !animalTypeCode && !animalTypeName){
        callback(new Error("请选择动物"))
      }
      callback()
    },
    async validatorCode(rule,formulaCode,callback){
      let pattern =/^[A-Za-z0-9]+$/
      if(formulaCode.length){
        if(!pattern.test(formulaCode)){
          callback(new Error('配方代码只能由数字和字母组成'))
          return
        }
        const result = await this.fetchPost({
          actions:this.checkFormulaCodeIsUnique,
          showMessage:false,
          data:{
            formulaCode
          }
        })
        result ? callback() : callback(new Error('配方代码重复'))
      }else{
       callback(new Error('请输入配方代码')) 
      }
    },
    nutritionChange(val){
      this.form.linkId = val
    },
    async detailInit(){
      await this.getDetail()
      this.$nextTick(()=>{
        this.formValue.animal = this.form.animalTypeName
        this.formValue.animalTypeName = this.form.animalTypeName
        this.animalName = this.form.animalTypeName
        this.form.animal= [this.form.animalTypeCode]

        this.moistureVolatilizeStart = this.form.moistureVolatilizeStart
        this.moistureVolatilizeUtil = this.form.moistureVolatilizeUtil

      })
      this.getLine()
      // if(!this.model.records || this.model.records.length === 0) await this.getModelList()
    },
    async getDetail(){
      await this.fetchGet({
        actions:this.customformulaDetail,
        name:'form',
        data:{
          id:this.formulaId,
        }
      })
    },
    getNutrition(arg ={}){
      this.fetchGet({
        actions:this.animalNutritionUserPage,
        name:'nutrition',
        data:{
          ...arg,
          size:1000
        }
      })
    },
    getCustomerList(arg ={}){
      this.fetchGet({
        actions:this.getCustomer,
        name:'customer',
        data:{
          ...arg,
          factoryId: window.localStorage.getItem('factoryId'),
          size:1000
        }
      })
    },

    animalChange(val){
      this.isChange = false
      if(val && val.length > 0){
        if(val.length > 1){
          const {name,id} =[...val].pop()
          const {id:animalRootId} =[...val].shift()
          this.form.animalTypeName = name
          this.form.animalTypeCode = id
          this.form.animalRootId = animalRootId
          this.animalName = name
          this.cascaderStyle = ''
          this.inputStyle = 'display: none'
        }
      } else{
        this.inputStyle = 'display: none'
        this.animalName = undefined
        this.form.animalTypeName = undefined
        this.form.animalTypeCode = undefined
        this.form.animalRootId = undefined
      }
    },


    async getModelList(arg={}){
      await this.fetchGet({
        actions:this.formulaModel,
        data:{
          size:300,
          current:1,
          animalTypeId: this.form.lineId,
          ...arg
        },
        name:'model'
      })
      if(this.model.records.length === 0) {
        this.model.records = []
      } else {
        this.modelCache = JSON.parse(JSON.stringify(this.model.records))
        this.formValue.model = '选择配方模型'
      }
    },

    // 创建配方
    ok(){
      this.$refs.ruleForm.validate( async (valid) => {
        if (valid) {
          const {type} = this.$route.query
          const { moistureVolatilizeStart, moistureVolatilizeUtil} = this
          const {analysisBase,analysisBaseUnit,animalTypeCode,animalTypeName,totalWeight,formulaName,factoryId,id,remark,priceSource,linkId,animalRootId,customId,price} = this.form
          const resData = {analysisBase,analysisBaseUnit,animalTypeCode,animalTypeName,totalWeight,formulaName:formulaName.replace(/\s*/g,""),factoryId,remark,priceSource,linkId,formulaType:  type||4 ,animalRootId,moistureVolatilizeStart,moistureVolatilizeUtil,customId}
          let feild = 'saveCustomFormula'
          if(id) {
            resData.id = id
            resData.price = price
            feild = 'updateCustomFormula'
          }
          // this.cleanForm()
          // this.$emit('ok',resData)
          this.saveLoading = true
          await this.fetchPost({
            actions: this[feild],
            isList: true,
            data: {
              ...resData,
              factoryId: this.factoryId,
              // current,
              // pageSize,
            },
          }).then(() => {
            this.cleanForm()
            this.$emit('close',true)
          }).finally(() => {
            this.saveLoading = false
          });
        } else {
          return false
        }
      })
    },

    cancel(){
      this.cleanForm()
      this.$emit('close',false)
    },

    cleanForm(){
      this.$refs.ruleForm.resetFields()
      this.form = {
        totalWeight:1000,
        analysisBaseUnit:'Kg',
        analysisBase:1,
        priceSource:'4'
      }
      this.formValue = {
        model:'选择配方模型',
        animal:'选择动物类型',
      }
      this.inputStyle = 'position: absolute;width: 100%;top:-7px;opacity: 1;background: #fff;top:-1px;color:rgba(0, 0, 0, 0.65);'
      this.cascaderStyle = 'opacity: 0'
    },

    onChange(val,select){
      this.animalChange(select,val)
      this.getLine()
    },
    async getLine(){
      let res = await this.fetchGet({
        actions:this.selectLineAnimalByAnimalId,
        data:{
          animalId: this.form.animalTypeCode,
        },
      })
      let {success,data} = res || {}
      if(success) {
        let {lineId} = data || {}
        this.form.lineId = lineId
        this.getModelList()
      }
    },
    mapFilter (i) {
      return {
        ...i,
        label:i.name,
        value:i.id,
        isLeaf: !i.hasChildren
      } 
    },

    async loadAnimalData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1]
      targetOption.loading = true
      const {value:parentId} = targetOption
      let factoryId = window.localStorage.getItem('factoryId')
      const res = await this.animalTypeList({parentId,factoryId})
      targetOption.loading = false
      targetOption.children = res.data.map(this.mapFilter)
      this.animal = [...this.animal]
    },

    async initAnimal(){
      let factoryId = window.localStorage.getItem('factoryId')
      const res = await this.animalTypeList({parentId:0,factoryId})
      const {data} = res
      if(data && data.length && data[0].id){
        const resAnimal = await this.animalTypeList({parentId:data[0].id,factoryId})
        this.animal = resAnimal.data.map(this.mapFilter)
      } else{
        this.animal = res.data.map(this.mapFilter)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  ::v-deep .ant-form-item{
    margin-bottom: 0;
  }
  ::v-deep .ant-space-item{
      font-size: 12px;
  }
</style>
